// extracted by mini-css-extract-plugin
export default {"bar":"LoadingBar_bar__YP7L+","loading":"LoadingBar_loading__dl9eX","text":"LoadingBar_text__WvPK-"};